import React, { useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function Loading({
  noText,
  fast,
  text,
  subText,
  height = null,
  width = null,
  margin = null,
  size = 40,
  color = 'inherit',
  scroll = true,
  fullscreen = false,
}) {
  const { t } = useTranslation();
  const flowType = useSelector((s) => s.flow.flowType);

  useEffect(() => {
    if (scroll) window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div
      className={`SlowShow ${fullscreen ? 'fullscreen-loader' : 'LoadingContainer'}`}
      style={{
        height: height || 'unset',
        width: width || 'unset',
        margin: margin || 'unset'
      }}
    >
      {fast ? (
        <CircularProgress style={{ color: color }} size={size} />
      ) : (
        <>
          <div className="loader-container">
            <div className="loader-back">
              <div className="loader-text">
                {text || t('loaderText')}
                <div className="loader-text-dots" />
              </div>
              <div className="loader-subtext">
                {subText ||
                  (flowType === 'Cost estimation'
                    ? t('loaderSubText_CE')
                    : t('loaderSubText'))}
              </div>
            </div>
          </div>
        </>
      )}
      {!noText && <div>{t('weAreAnalyzing')}...</div>}
    </div>
  );
}

export default Loading;
